import React from 'react';
import { Award, Target } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const AboutSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section id="about" className="py-20 bg-white relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#c4a35a]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#c4a35a]/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Section */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/scales-justice.jpg"
                alt="Scales of Justice"
                className="w-full h-[500px] object-cover brightness-110" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1117]/80 to-transparent" />
              <div className="absolute bottom-8 left-8 right-8">
                <div className="backdrop-blur-sm p-6 rounded-lg !opacity-[0%] bg-[#c4a35a]/90">
                  <div className="text-4xl font-bold text-[#0f1117] mb-1">24+</div>
                  <div className="text-[#0f1117] font-medium">{t.yearsExperience}</div>
                  <div className="text-sm text-[#0f1117]/80">{t.experienceLabel}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="space-y-6">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1a1d2e] mb-4">
                {t.aboutTitle}
              </h2>
              <div className="w-20 h-1 bg-[#c4a35a]" />
            </div>

            <p className="text-gray-600 text-lg leading-relaxed">
              {t.aboutDescription}
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default AboutSection;